export default "/images/square.svg?8c2fd5ee4efa3610011214c0ea27b3ee";